import ComplianceOverview from '@/components/dashboard/ComplianceOverview'
import CompliancePerformanceOverview from '@/components/dashboard/CompliancePerformanceOverview'
import GlobalComplianceFootprint from '@/components/dashboard/GlobalComplianceFootprint'
import MonthlyWHTTrend from '@/components/dashboard/MonthlyWHTTrend'
import StatBoxGrid from '@/components/dashboard/StatBoxGrid'
import TopWhtContributingVendorsGraph from '@/components/dashboard/TopWhtContributingVendorsGraph'
import TopWhtPaymentCategoriesGraph from '@/components/dashboard/TopWhtPaymentCategoriesGraph'
import WHTVarianceSummary from '@/components/dashboard/WHTVarianceSummary'
import { Box } from '@mui/material'
import { useSelector } from 'react-redux'

const DashboardTab = () => {
  // ==================== Hooks ====================
  // The committed filters the dashboard fetches on. Changes only on Apply /
  // Reset (and the initial options load) — never on transient country
  // selection. Each child component reads the committed filters directly and
  // fetches its own data; this tab only decides which country-scope card to
  // render.
  const appliedFilters = useSelector(
    state => state.dashboardFilter.appliedFilters
  )

  // ==================== Derived Data ====================
  // Country scope is driven by the committed filters. A single country renders
  // the compliance overview; more than one renders the global footprint map.
  const countriesCount = appliedFilters.countries.length

  // ==================== Return ====================
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, my: 2 }}>
      {/* Stat Boxes */}
      <StatBoxGrid />

      {/* Dashboard Cards */}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
        {countriesCount > 1 ? (
          <GlobalComplianceFootprint />
        ) : (
          <ComplianceOverview />
        )}
        <CompliancePerformanceOverview />
        <WHTVarianceSummary />
      </Box>

      {/* Monthly WHT Trend */}
      <MonthlyWHTTrend />

      {/* Top WHT Graphs */}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
        <TopWhtContributingVendorsGraph />
        <TopWhtPaymentCategoriesGraph />
      </Box>
    </Box>
  )
}

export default DashboardTab
